import { render, staticRenderFns } from "./courseAdv.vue?vue&type=template&id=e1542c48"
import script from "./courseAdv.vue?vue&type=script&lang=js"
export * from "./courseAdv.vue?vue&type=script&lang=js"
import style0 from "./courseAdv.vue?vue&type=style&index=0&id=e1542c48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports